export default "__VITE_ASSET__c4a3baa1__"